var map = {
	"./text-accordion/text-accordion.js": "./src/block/text/text-accordion/text-accordion.js",
	"./text-accordion/text-accordion.scss": "./src/block/text/text-accordion/text-accordion.scss",
	"./text-with-bg/text-with-bg.scss": "./src/block/text/text-with-bg/text-with-bg.scss",
	"./text/text.js": "./src/block/text/text/text.js",
	"./text/text.scss": "./src/block/text/text/text.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/block/text sync recursive ^\\.\\/[^/]+\\/[^/.]+\\.(js%7Ccss%7Cscss%7Csass%7Cless)$";